<!--=====================================
    Breadcrumb
    ======================================-->

<div class="ps-breadcrumb">

  <div class="container">

    <ul class="breadcrumb">

      <li><a routerLink="/">Inicio</a></li>
      
      <li>{{productName |titlecase}}</li>
    </ul>

  </div>

</div>
